module.exports = __webpack_public_path__ + "img/6.d617d46d.png";